// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div[data-v-4ee8580f] {\n  display: inline-block;\n}\nbutton.el-button[data-v-4ee8580f] {\n  margin-right: 5px;\n  display: inline-block;\n}\n.button_default[data-v-4ee8580f] {\n  color: #c34231;\n  padding: 0 10px;\n  border-right: 1px solid #dcdfe6;\n  cursor: pointer;\n}\n.button_default[data-v-4ee8580f]:last-child {\n  border-right: 0;\n}\n", ""]);
// Exports
module.exports = exports;
